import { render, staticRenderFns } from "./TripStatsView.vue?vue&type=template&id=df8db4a2"
import script from "./TripStatsView.vue?vue&type=script&lang=ts"
export * from "./TripStatsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports